import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryOnHandExceptionReport'
import Component from 'components/Reports/InventoryOnHandExceptionReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryOnHandExceptionReport })(Component)
